/**
 * HerramientasDelAgente — GEN-TL-006: sección «Herramientas» de la ficha del
 * agente. Solo lectura: cada herramienta con el nivel o los niveles que el
 * agente tiene en su ficha (GET /v1/agentes/{id}/herramientas; GEN-TL-008: es el
 * mismo dato que aplica el kernel). Sin herramientas: lo dice. Esto no concede
 * ni cambia nada.
 */

import { useEffect, useState } from 'react'
import { getHerramientasAgente } from '../api/client.js'
import MarcasConfirmacion from './MarcasConfirmacion.jsx'

export default function HerramientasDelAgente({ agenteId }) {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    setDatos(null)
    let vivo = true
    getHerramientasAgente(agenteId)
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se han podido cargar las herramientas.' }))
    return () => { vivo = false }
  }, [agenteId])

  const herramientas = datos?.herramientas ?? []
  const sinCatalogo = datos?.sin_catalogo ?? []
  const vacio = datos && !datos.error && herramientas.length === 0 && sinCatalogo.length === 0
  return (
    <section className="ficha-card" aria-label="Herramientas">
      <h3 className="ficha-card__titulo">Herramientas</h3>
      {!datos && <p className="equipo-estado">Cargando…</p>}
      {datos?.error && <p className="equipo-estado" role="alert">{datos.error}</p>}
      {vacio && <p className="ficha-card__texto">No tiene herramientas.</p>}
      {herramientas.length > 0 && (
        <ul className="niveles-lista">
          {herramientas.map(h => (
            <li key={h.id} className="niveles-lista__item">
              <span className="niveles-lista__nombre">{h.nombre}</span>
              {h.concedido?.texto ? (
                // GEN-TL-009: el nivel concedido (el más alto) y que incluye los de debajo.
                <>
                  <p className="ficha-card__texto" aria-label={`Nivel de ${h.nombre}`}>{h.concedido.texto}</p>
                  <MarcasConfirmacion niveles={h.niveles} nombre={h.nombre} />
                </>
              ) : (
                <ul className="equipo-card__chips" aria-label={`Niveles de ${h.nombre}`}>
                  {h.niveles.map(n => (
                    <li key={n.clave_recurso} className="equipo-chip">
                      {n.nombre}
                      {n.pide_confirmacion && <span className="equipo-chip equipo-chip--confirmacion">Pide confirmación</span>}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
      {sinCatalogo.length > 0 && (
        <p className="ficha-card__texto" role="note">
          Claves de la ficha sin herramienta en el catálogo: {sinCatalogo.map(r => r.recurso).join(', ')}.
        </p>
      )}
    </section>
  )
}
